import React, { FC, useState } from 'react'
import { Menu } from '@blueprintjs/core'
import BookingCalendar from '../BookingCalendar'
import { Button, Popover } from '@ui'
import { DateUtil } from '@utils/dateUtil'
import { MaxDuration } from '@api'
import { useFloor } from '@providers/mapProvider'

type PopupCalendarPropsT = {
  value?: string
  timezone?: string
  allDay?: boolean
  selectedDates?: DateUtil[]
  constraints?: { first?: DateUtil; last?: DateUtil }
  showTime?: boolean
  className?: string
  enableMultipleDays?: boolean
  onDateSelect: (dates: DateUtil[]) => void
  onTimeChange?: ({ fromDate, toDate }: { fromDate: DateUtil; toDate: DateUtil }) => void
  closeOnDateSelect?: boolean
  headerRender?: JSX.Element
}

const PopupCalendar: FC<PopupCalendarPropsT> = ({
  timezone,
  value,
  selectedDates,
  allDay = false,
  constraints,
  showTime,
  className,
  closeOnDateSelect = true,
  enableMultipleDays,
  headerRender,
  onDateSelect,
  onTimeChange,
}) => {
  const [isOpen, setOpen] = useState(false)
  const openCalendar = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }
  const floor = useFloor()
  return (
    <>
      <Popover
        isOpen={isOpen}
        content={
          <BookingCalendar
            timezone={timezone}
            selectedDates={selectedDates}
            allDaySetting={allDay}
            options={[]}
            headerRender={headerRender}
            constraints={constraints}
            enableMultipleDays={enableMultipleDays}
            is24Hr={true}
            onTimeChange={(dates) => {
              !allDay && onTimeChange && onTimeChange(dates)
            }}
            showTime={showTime}
            validateDateTime={false}
            //TODO remove the console.log after implementing
            onDateChange={(dates) => {
              onDateSelect(dates)
              closeOnDateSelect && onClose()
            }}
            floor={floor}
          />
        }
        modifiers={{ arrow: { enabled: false } }}
        onClose={onClose}>
        <Button className={className} text={value || 'Date'} onClick={openCalendar}></Button>
        {/* <Menu style={{ minWidth: 240 }}></Menu> */}
      </Popover>
    </>
  )
}

export default PopupCalendar
